import * as types from "../Actions/Types";
import { ISalesPerformanceData } from "../Models/Models";

export interface ISalesPerformanceReducerState {
  performanceData: ISalesPerformanceData;
  loading: boolean;
}

const defaultState: ISalesPerformanceReducerState = {
    performanceData: null,
    loading: true,
};

export const salesPerformanceReducer = (
    state: ISalesPerformanceReducerState = { ...defaultState },
    action
): ISalesPerformanceReducerState => {
    switch (action.type) {
        case types.SALES_PERFORMANCE_SET_DATA:
            return Object.assign({}, state, {
                performanceData: action.data,
            });
        case types.SALES_PERFORMANCE_SET_LOADING:
            return Object.assign({}, state, {
                loading: action.data,
            });
        default:
            return state;
    }
};
